<template>
  <div class="certification">
    <title-bar-back :title="'实名认证'" @back="back">
      <div class="title_right"></div>
    </title-bar-back>
    <!-- 实名列表 -->
    <van-pull-refresh v-model="loading" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="!findCertificationByPage.hasNextPage"
        @load="onLoad"
      >
        <div
          v-for="(item, index) in findCertificationByPage.rows"
          :key="index"
          class="certification_list"
        >
          <div class="list_item text_left">
            <div class="item_top">
              <div class="top_name font14 font_weight400 colo0">
                {{ item.idcardName }}
              </div>
              <div class="top_num font12 font_weight400 colo0">
                {{ item.idcardNumber }}
              </div>
            </div>
            <!-- item.isDefault === 1 -->
            <div class="item_bottom font10 font_weight400 colo0 clearfix">
              <div class="left left_icon" @click="setDefault(item.id, index)">
                <img :src="item.isDefault ? chooseIcon : unChooseIcon" alt="" />
              </div>
              <div class="left left_det">账户默认实名人</div>
              <img
                src="@/assets/mine/icon_delete@2x.png"
                alt=""
                class="right right_delete"
                @click="deleteList(index, item.id)"
              />
            </div>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
    <!-- 添加实名认证按钮 -->
    <div class="add_list font14 font_weight500" @click="addList">
      + 添加实名信息
    </div>
  </div>
</template>
<script>
const TitleBarBack = () =>
  import("@/components/TitleBarBack").then(m => m.default || m);
export default {
  name: "CertificationList",
  components: {
    TitleBarBack
  },
  data() {
    return {
      list: [1, 2, 3, 4, 5, 6],
      loading: false,
      chooseIcon: require("@/assets/login/select@2x.png"),
      unChooseIcon: require("@/assets/login/unselect@2x.png")
    };
  },
  computed: {
    findCertificationByPage() {
      return this.$store.getters.findCertificationByPage;
    }
  },
  // watch: {
  //   findCertificationByPage: {
  //     handler(n, o) {
  //       console.log(n, o);
  //     },
  //     deep: true
  //   }
  // },
  created() {
    this.getDate();
  },
  methods: {
    back() {
      this.$router.back();
    },
    getDate() {
      // findCertificationByPage
      const params = {
        kind: "Registered"
      };
      this.$store
        .dispatch("mine/findCertificationByPage", { params })
        .then(() => {})
        .catch(() => {});
    },
    onLoad() {
      // console.log("上拉进行中");
      this.loading = false;
      if (
        this.findCertificationByPage.hasNextPage &&
        this.findCertificationByPage.pageNo <=
          this.findCertificationByPage.pageCount
      ) {
        this.loading = true;
        const pageIndex = this.findCertificationByPage.pageNo + 1;
        this.getAllData(pageIndex);
        // console.log("上拉完毕");
      }
    },
    onRefresh() {
      this.getDate();
    },
    // 删除
    deleteList(index, id) {
      this.$dialog
        .confirm({
          // title: "暂停配送",
          message: "确定删除该实名人？",
          confirmButtonText: "确定",
          confirmButtonColor: "#DD9132"
        })
        .then(() => {
          const params = { id };
          this.$store
            .dispatch("mine/removeCertification", { params })
            .then(() => {
              this.$toast("删除成功");
              this.findCertificationByPage.rows.splice(index, 1);
              // this.getDate();
            })
            .catch(() => {});
        })
        .catch(() => {
          // console.log(123)
        });
    },
    addList() {
      this.$router.push({
        path: "/mine/addcertification",
        query: {
          id: this.$route.query.id
        }
      });
    },
    // 设置默认
    setDefault(id) {
      // 调用设置默认 setDefault
      const params = { id };
      this.$store
        .dispatch("mine/setDefault", { params })
        .then(() => {
          // this.findCertificationByPage.rows[index].isDefault = !this
          //   .findCertificationByPage.rows[index].isDefault;
          this.getDate();
          this.$toast("设置成功");
        })
        .catch(() => {});
    }
  }
};
</script>
<style lang="less" scoped>
.title_right {
  width: 36px;
}
.certification {
  .certification_list {
    margin: 12px;
    background: #fff;
  }
  .list_item {
    .item_top {
      padding: 8px 16px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.06);
      .top_name {
        line-height: 20px;
      }
      .top_num {
        line-height: 14px;
        margin-top: 6px;
      }
    }
    .item_bottom {
      line-height: 14px;
      padding: 6px 16px 8px;
      .border_none {
        border-radius: 50%;
        border: 1px solid rgba(0, 0, 0, 0.06);
      }
      .left_icon {
        width: 18px;
        height: 18px;
        img {
          display: block;
          width: 100%;
        }
      }
      .right_delete {
        // padding-left: 30px;
        // margin-top: 2px;
        display: block;
        width: 16px;
        height: 16px;
      }
      .left_det {
        padding-left: 4px;
        line-height: 18px;
      }
    }
  }
  .add_list {
    margin: 12px;
    background: linear-gradient(90deg, #e1c49d 0%, #bf9264 100%);
    border-radius: 2px;
    color: #fff;
    line-height: 50px;
  }
}
</style>
